import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Copy, Flex, Box, Button, Check, CheckButton, Icon, themeColor, Hide } from '@elparking/components'

import ParkingService from './ParkingService'

import styled from 'styled-components'

import messages from './messages'
import TabFilterMobile, { AIRPORT, ALL_PLACES } from './TabFilterMobile'

import {
    updateFilters,
    getDefaultFilters,
    isPickUpBookingServiceEnabled,
    isWalkingBookingServiceEnabled,
    isAirportTransferBookingServiceEnabled,
    isDisabledAccessParkingServiceFilterEnabled,
    isCarChargePointParkingServiceFilterEnabled,
    isOpen24ParkingServiceFilterEnabled,
    isBicycleParkingServiceFilterEnabled,
    isTruckParkingServiceFilterEnabled,
    isBusParkingServiceFilterEnabled,
    isCaravansParkingServiceFilterEnabled,
    isVansParkingServiceFilterEnabled,
    isMotorcycleParkingServiceFilterEnabled,
    isCarParkingServiceFilterEnabled,
    isAenaParkingProviderFilterEnabled,
    isAirportParkingTypeFilterEnabled,
} from '../../util/parkingsFilter'

export const FilterSectionContainer = styled(Flex)`
    flex-wrap: wrap;
    border: 1px solid ${themeColor('gray20')};
`

export const AenaCheckboxContainer = styled(Flex)`
    border-top: 1px solid ${themeColor('gray20')};
    margin-top: 1em;
`

export const FilterButtonContainer = styled(Flex)`
    background: white;
`

const HeaderFilterMobile = styled(Flex)`
    background: white;
`
const FilterBody = styled(Box)`
    overflow-y: auto;
`
const FilterContainer = styled(Flex)`
    max-height: 100%;
`

const ButtonCancel = styled(Button)`
    color: ${themeColor('gray60')};
    max-height: 100%;
    background: transparent;

    :hover {
        background: transparent;
        color: ${themeColor('black')};
    }
`

const AenaIcon = styled.img`
    width: 30px;
    height: 30px;
`

const airportService = [
    {
        text: messages.airportTransfer,
        value: 'airportTransfer',
        icon: 'bus-filled',
        isEnabled: isAirportTransferBookingServiceEnabled,
    },
    {
        text: messages.pickUp,
        value: 'pickUp',
        icon: 'valet',
        isEnabled: isPickUpBookingServiceEnabled,
    },
    {
        text: messages.walking,
        value: 'walking',
        icon: 'walk',
        isEnabled: isWalkingBookingServiceEnabled,
    },
]

const serviceTypes = [
    {
        text: messages.open24,
        value: 'open24',
        isEnabled: isOpen24ParkingServiceFilterEnabled,
    },
    {
        text: messages.carChargePoint,
        value: 'carChargePoint',
        isEnabled: isCarChargePointParkingServiceFilterEnabled,
    },
    {
        text: messages.disabledAccess,
        value: 'disabledAccess',
        isEnabled: isDisabledAccessParkingServiceFilterEnabled,
    },
]

const vehicleType = [
    {
        text: messages.car,
        value: 'car',
        icon: 'car',
        isEnabled: isCarParkingServiceFilterEnabled,
    },
    {
        text: messages.motorcycle,
        value: 'motorcycle',
        icon: 'motorbike',
        isEnabled: isMotorcycleParkingServiceFilterEnabled,
    },
    {
        text: messages.vans,
        value: 'vans',
        icon: 'van',
        isEnabled: isVansParkingServiceFilterEnabled,
    },
    {
        text: messages.caravans,
        value: 'caravans',
        icon: 'caravan',
        isEnabled: isCaravansParkingServiceFilterEnabled,
    },
    {
        text: messages.bus,
        value: 'bus',
        icon: 'bus',
        isEnabled: isBusParkingServiceFilterEnabled,
    },
    {
        text: messages.bicycle,
        value: 'bicycle',
        icon: 'bike',
        isEnabled: isBicycleParkingServiceFilterEnabled,
    },
    {
        text: messages.truck,
        value: 'truck',
        icon: 'truck',
        isEnabled: isTruckParkingServiceFilterEnabled,
    },
]

export class MoreFilters extends React.Component {
    static propTypes = {
        intl: PropTypes.object,
        filters: PropTypes.object,
        onClose: PropTypes.func,
        setFilters: PropTypes.func,
    }

    static defaultProps = {
        filters: getDefaultFilters(),
        setFilters: () => {},
        onClose: () => {},
    }

    state = {
        filters: this.props.filters,
        parkingTypeAirport: null,
    }

    handleSelectedTab = this.handleSelectedTab.bind(this)
    handleAirportFiltersChange = this.handleAirportFiltersChange.bind(this)
    handleVehicleFiltersChange = this.handleVehicleFiltersChange.bind(this)
    handleCheckboxParkingService = this.handleCheckboxParkingService.bind(this)
    handleCheckboxAena = this.handleCheckboxAena.bind(this)
    handleApplyFilters = this.handleApplyFilters.bind(this)

    static getDerivedStateFromProps ({ filters }, state) {
        if (filters !== state.filters) {
            return {
                filters: updateFilters(state.filters, {
                    parkingType: {
                        ...state.filters.parkingType,
                        airport: filters.parkingType.airport,
                    },
                }),
            }
        }
        return null
    }

    handleSelectedTab (parkingType) {
        this.setState({parkingTypeAirport: parkingType === AIRPORT})
    }

    handleAirportFiltersChange (value, selected) {
        let newState = {bookingService: {[value]: selected}}
        this.setState({filters: updateFilters(this.state.filters, newState)})
    }

    handleVehicleFiltersChange (value, selected) {
        let newState = {parkingService: {[value]: selected}}
        this.setState({filters: updateFilters(this.state.filters, newState)})
    }

    handleCheckboxParkingService (target) {
        let newState = {parkingService: {[target.name]: target.checked}}
        this.setState({ filters: updateFilters(this.state.filters, newState) })
    }

    handleCheckboxAena (target) {
        let newState = {parkingProvider: {aena: target.checked}}
        this.setState({filters: updateFilters(this.state.filters, newState)})
    }

    handleApplyFilters () {
        const { filters, parkingTypeAirport } = this.state

        this.props.setFilters({
            ...filters,
            parkingType: {
                ...filters.parkingType,
                airport: parkingTypeAirport !== null
                    ? parkingTypeAirport
                    : filters.parkingType.airport,
            },
        })
        this.props.onClose()
    }

    renderCheckbox (service, index) {
        return (
            <Box key={index} w={['100%', '50%']} p='10px 10px 10px 0'>
                <Check
                  checked={service.isEnabled(this.state.filters)}
                  checkButtonElement={CheckButton.squared}
                  id={service.value}
                  name={service.value}
                  label={this.props.intl.formatMessage(service.text)}
                  onChange={({target}) => this.handleCheckboxParkingService(target)}
                  type='checkbox' />
            </Box>
        )
    }

    renderVehicleType (vehicle) {
        return (
            <Flex alignItems='flex-start'>
                <Icon size='xxLarge' type={vehicle.icon} color='inherit' />
                <Copy size='xSmall' color='inherit' fontWeight='regular' padding='3px 0 0 1em'>{this.props.intl.formatMessage(vehicle.text)}</Copy>
            </Flex>
        )
    }

    renderAirportService (service) {
        return (
            <Flex flexDirection='column' alignItems='center'>
                <Icon type={service.icon} size='xxLarge' color='inherit' />
                <Copy size='xxSmall' color='inherit' fontWeight='regular' padding='0.8em 0 0 0'>{this.props.intl.formatMessage(service.text)}</Copy>
            </Flex>
        )
    }

    renderAenaCheckbox () {
        return (
            <AenaCheckboxContainer w='100%' justifyContent='space-between' alignItems='center' pt='1em'>
                <Flex alignItems='center'>
                    <AenaIcon src='/images/booking-process/aena_ic.svg' />
                    <Flex flexDirection='column' pl='0.5em'>
                        <Copy size='small' padding='0' fontWeight='regular'>{this.props.intl.formatMessage(messages.onlyAena)}</Copy>
                        <Copy size='xxxSmall' padding='0' color='gray' fontWeight='regular'>{this.props.intl.formatMessage(messages.oficialParkings)}</Copy>
                    </Flex>
                </Flex>
                <Check
                  checkButtonElement={CheckButton.toggle}
                  checked={isAenaParkingProviderFilterEnabled(this.state.filters)}
                  id='aena'
                  name='aena'
                  type='checkbox'
                  onChange={({target}) => { this.handleCheckboxAena(target) }}
                />
            </AenaCheckboxContainer>
        )
    }

    renderAirportServiceFilters () {
        return (
            <FilterSectionContainer justifyContent='space-between' px={['0.5em', '1.5em']} py='1em' mb='1em'>
                <Copy w='100%' transform='uppercase' padding='0 0 1em 0' color='gray60'>{this.props.intl.formatMessage(messages.serviceAirportParkings)}</Copy>
                <Flex w='100%' justifyContent='space-between'>
                    {airportService.map((service, index) => {
                        return <ParkingService
                          key={index}
                          value={service.value}
                          selected={service.isEnabled(this.state.filters)}
                          width='32%'
                          onClick={this.handleAirportFiltersChange}
                               >{this.renderAirportService(service)}
                        </ParkingService>
                    })}
                </Flex>
                {this.renderAenaCheckbox()}
            </FilterSectionContainer>
        )
    }

    typeOfTabSelected () {
        const { parkingTypeAirport, filters } = this.state

        const isAirportType = parkingTypeAirport !== null
            ? parkingTypeAirport
            : isAirportParkingTypeFilterEnabled(filters)

        return isAirportType ? AIRPORT : ALL_PLACES
    }

    render () {
        return (
            <FilterContainer flexDirection='column'>
                <HeaderFilterMobile flex='1 0 auto' flexDirection='column' p={['0 1em 0.5em 1em', '0']} mb={['0', '1em']}>
                    <Copy size='xxLarge' padding='0'>{this.props.intl.formatMessage(messages.moreFilters)}</Copy>
                </HeaderFilterMobile>
                <Hide md lg>
                    <TabFilterMobile selected={this.typeOfTabSelected()} onClickTab={this.handleSelectedTab} />
                </Hide>
                <FilterBody p={['1em', '0']}>
                    {isAirportParkingTypeFilterEnabled(this.state.filters) && this.renderAirportServiceFilters()}
                    <FilterSectionContainer justifyContent='space-between' px={['0.5em', '1.5em']} py='1em' mb='1em'>
                        <Copy w='100%' transform='uppercase' padding='0 0 1em 0' color='gray60'>{this.props.intl.formatMessage(messages.vehicleType)}</Copy>
                        {vehicleType.map((vehicle) => {
                            return <ParkingService
                              key={vehicle.value}
                              value={vehicle.value}
                              selected={vehicle.isEnabled(this.state.filters)}
                              width='48%'
                              onClick={this.handleVehicleFiltersChange}
                                   >{this.renderVehicleType(vehicle)}
                            </ParkingService>
                        })}
                    </FilterSectionContainer>
                    <FilterSectionContainer justifyContent='space-between' px={['0.5em', '1.5em']} py='1em' mb='1em'>
                        <Copy w='100%' transform='uppercase' padding='0 0 1em 0' color='gray60'>{this.props.intl.formatMessage(messages.serviceParkings)}</Copy>
                        {serviceTypes.map((service, index) => {
                            return this.renderCheckbox(service, index)
                        })}
                    </FilterSectionContainer>
                </FilterBody>
                <Hide md lg>
                    <FilterButtonContainer flex='1 0 auto' w={['100%']} justifyContent='center' alignItems='center' p='1em'>
                        <Button width='90%' onClick={this.handleApplyFilters}>{this.props.intl.formatMessage(messages.applyFilters)}</Button>
                    </FilterButtonContainer>
                </Hide>
                <Hide sm xs>
                    <FilterButtonContainer flex='1 0 auto' w={['100%']} justifyContent='flex-end'>
                        <ButtonCancel width='30%' onClick={() => { this.props.onClose() }}>{this.props.intl.formatMessage(messages.cancel)}</ButtonCancel>
                        <Button width='30%' onClick={this.handleApplyFilters}>{this.props.intl.formatMessage(messages.applyFilters)}</Button>
                    </FilterButtonContainer>
                </Hide>
            </FilterContainer>
        )
    }
}

export default injectIntl(MoreFilters)
